import React, { Suspense } from 'react';
import { Navigate, useLocation, Outlet } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { RootState } from '../app/store';

// Lazy load NotFound for access denied
const NotFound = React.lazy(() => import('../pages/NotFound'));

const SuperAdminRoute: React.FC = () => {
  const location = useLocation();
  const { user, token } = useSelector((state: RootState) => state.auth);

  // Not logged in → redirect to admin login
  if (!token || !user) {
    return <Navigate to="/admin/login" state={{ from: location }} replace />;
  }

  // Not a superadmin → show 404 page
  if (user.role !== 'superadmin') {
    return (
      <Suspense fallback={<div></div>}>
        <NotFound />
      </Suspense>
    );
  }

  return <Outlet />;
};

export default SuperAdminRoute;
